import { get, includes, isEmpty, map } from 'lodash'

const permitCanBeSigned = (isUserExtern, permit, type, profile) => {
  const isUserAssociatedUser =
    get(permit, 'companyLeader.id') === get(profile, 'id')

  let isFullySignedBySDLP
  switch (type) {
    case 'firePermit':
      isFullySignedBySDLP =
        get(permit, 'isFullySignedBySDLP') && get(permit, 'permit.')
      break
    case 'searchPermit':
      isFullySignedBySDLP = get(permit, 'permit.isFullySignedBySDLP')
      break
    case 'capacityPermit':
      isFullySignedBySDLP = get(permit, 'permit.isFullySignedBySDLP')
      break
    default:
      isFullySignedBySDLP = get(permit, 'isSupervisorSigned')
      break
  }

  const canBeSignedByExtern = isUserAssociatedUser && isFullySignedBySDLP

  return (
    !get(permit, 'isSigned') &&
    get(permit, 'isMainPermitSigned') &&
    !includes(['waiting', 'closed', 'requested'], get(permit, 'status')) &&
    (!isUserExtern || canBeSignedByExtern)
  )
}

const canBeEdited = (isRightType, isSigned, isUserExtern) => {
  return isRightType && !isUserExtern
}

const canBeClosed = (permit, isUserExtern) => {
  return (
    (get(permit, 'status') === 'opened' ||
      get(permit, 'status') === 'finished') &&
    ((isEmpty(get(permit, 'firePermits')) &&
      isEmpty(get(permit, 'searchPermits')) &&
      isEmpty(get(permit, 'cleaningPermits')) &&
      isEmpty(get(permit, 'capacityPermits'))) ||
      get(permit, 'firePermits').every(
        currentValue =>
          get(currentValue, 'status') === 'closed' ||
          get(currentValue, 'status') === 'cancelled'
      )) &&
    (isEmpty(get(permit, 'searchPermits')) ||
      get(permit, 'searchPermits').every(
        currentValue =>
          get(currentValue, 'status') === 'closed' ||
          get(currentValue, 'status') === 'cancelled'
      )) &&
    (isEmpty(get(permit, 'cleaningPermits')) ||
      get(permit, 'cleaningPermits').every(
        currentValue =>
          get(currentValue, 'status') === 'closed' ||
          get(currentValue, 'status') === 'cancelled'
      )) &&
    (isEmpty(get(permit, 'capacityPermits')) ||
      get(permit, 'capacityPermits').every(
        currentValue =>
          get(currentValue, 'status') === 'closed' ||
          get(currentValue, 'status') === 'cancelled'
      )) &&
    !isUserExtern
  )
}

const canValidateControl = (permit, isUserExtern, isUserReader) => {
  return (
    get(permit, 'status') === 'finished' &&
    get(permit, 'isSigned') &&
    !get(permit, 'isControlled') &&
    !isUserExtern
  )
}

const canAskConfirmRequest = (type, status, isUserExtern, isUserReader) => {
  const isMainPermit = type === 'workingPermit'
  return (
    isMainPermit && status === 'requested' && !isUserExtern && !isUserReader
  )
}

const canDuplicate = (permit, isUserExtern) => {
  return permit.status !== 'requested' && !isUserExtern
}

/**
 * Can be deleted only if the a sub-permit is not signed and if the user is extern
 */
const canDelete = (type, isSigned, isUserExtern) => {
  const isMainPermit = type === 'workingPermit'

  if (isMainPermit || isSigned) {
    return false
  }

  return !isUserExtern
}

export const getPermitActionsRights = ({ permit, type, profile }) => {
  const isSigned = get(permit, 'isSigned') === true

  const rolesName = map(get(profile, 'roles'), ({ name }) => name)
  const isUserReader = includes(map(get(profile, 'roles'), 'name'), 'READER')
  const isUserExtern =
    includes(map(get(profile, 'roles'), 'name'), 'EXTERN_CREATOR') ||
    includes(map(get(profile, 'roles'), 'name'), 'EXTERN_READER')

  return {
    notReader: !includes(rolesName, 'reader'),
    canBeSigned: permitCanBeSigned(isUserExtern, permit, type, profile),
    canBeEdited: {
      capacityPermit: canBeEdited(
        type === 'capacityPermit',
        isSigned,
        isUserExtern
      ),
      cleaningPermit: canBeEdited(
        type === 'cleaningPermit',
        isSigned,
        isUserExtern
      )
    },
    canBeCancelled: get(permit, 'status') === 'waiting' && !isUserExtern,
    canBeClosed: canBeClosed(permit, isUserExtern),
    canValidateControl: canValidateControl(permit, isUserExtern),
    canAskConfirmRequest: canAskConfirmRequest(
      type,
      permit.status,
      isUserExtern,
      isUserReader
    ),
    canDuplicate: canDuplicate(permit, isUserExtern),
    canDelete: canDelete(type, isSigned, isUserExtern)
  }
}
